<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button
          class="mr-2"
          variant="warning"
          @click="opeSetAutoApplyModal()"
        >
          查詢設定自動扣款資料
        </b-button>

        <b-button class="mr-2" variant="success" @click="exportMember()">匯出契約</b-button>

        <b-button
          variant="primary"
          v-auth="`update`"
          @click="openContractAddEditModal('new')"
        >
          新增
        </b-button>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-select
          v-model="search.status"
          :options="options.type" />

        <date-picker
          v-model="search.join_date_S"
          :position="'left'"
          placeholder="入會日期開始"
        ></date-picker>

        <date-picker
          v-model="search.join_date_E"
          :position="'left'"
          placeholder="入會日期結束"
        ></date-picker>

        <b-form-select
          v-if="status.moreFilter"
          v-model="search.help_check"
          :options="options.helpCheck"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 身故列為下次互助名單 --</b-form-select-option>
          </template>
        </b-form-select>

        <!-- <b-form-select
          v-if="status.moreFilter"
          v-model="search.deferred_check"
          :options="options.deferredCheck"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 身故列為下次遞延名單 --</b-form-select-option>
          </template>
        </b-form-select> -->

        <div class="blur">
          <b-form-input
            placeholder="關鍵字"
            v-model="search.blur"
            @keyup.enter="getMember(1)"
            @input="changeFilterValue('blur')" />

          <!-- <div id="blur_info" class="blur-info">i</div> -->
        </div>

        <b-form-input
          v-if="status.moreFilter"
          class="mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="search.number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="search.sales_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('sales_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務姓名"
          v-model="search.sales_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('sales_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務身分證"
          v-model="search.sales_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('sales_ID_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="要助人姓名"
          v-model="search.pay_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('pay_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="要助人身分證"
          v-model="search.pay_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('pay_ID_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="互助人姓名"
          v-model="search.member_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('member_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="互助人身分證"
          v-model="search.member_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('member_ID_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="受款人姓名"
          v-model="search.beneficiary_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('beneficiary_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="受款人身分證"
          v-model="search.beneficiary_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('beneficiary_ID_number')" />

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_off_at_S"
          :position="'left'"
          placeholder="繳滿日期開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_off_at_E"
          :position="'left'"
          placeholder="繳滿日期結束"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.dead_at_S"
          :position="'left'"
          placeholder="身故日期開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.dead_at_E"
          :position="'left'"
          placeholder="身故日期結束"
        ></date-picker>

        <b-form-select
          v-if="status.moreFilter"
          v-model="search.stop_history"
          :options="options.stopHistory"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 是否曾經停效 --</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select
          v-if="status.moreFilter"
          v-model="search.bill_pay_status"
          :options="options.billPayStatus"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 是否繳費 --</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select
          v-if="status.moreFilter"
          v-model="search.loan_status"
          :options="options.loanStatus"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 預領狀態 --</b-form-select-option>
          </template>
        </b-form-select>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.bill_pay_status_at_S"
          :position="'left'"
          placeholder="繳費日期開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.bill_pay_status_at_E"
          :position="'left'"
          placeholder="繳費日期結束"
        ></date-picker>

        <!-- <date-picker
          v-if="status.moreFilter"
          v-model="search.member_birthday_S"
          :position="'left'"
          placeholder="互助人生日開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.member_birthday_E"
          :position="'left'"
          placeholder="互助人生日結束"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_birthday_S"
          :position="'left'"
          placeholder="要助人生日開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_birthday_E"
          :position="'left'"
          placeholder="要助人生日結束"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.sales_birthday_S"
          :position="'left'"
          placeholder="業務生日開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.sales_birthday_E"
          :position="'left'"
          placeholder="業務生日結束"
        ></date-picker> -->
        <!-- <b-form-checkbox
          v-if="status.moreFilter"
          switch size="lg"
          v-model="search.pay_off_status"
          value=1
          unchecked-value=0
        >
          是否繳滿
        </b-form-checkbox> -->
        <div v-if="status.moreFilter" class="d-flex align-items-center justify-content-center">
          <b-form-input v-model="search.sales_name_system" class="w-100" readonly></b-form-input>

          <b-button
            class="ml-2"
            variant="primary"
            size="sm"
            @click="openBusinessModal"
          >
            搜尋業務體系
          </b-button>
        </div>

        <b-button @click="status.moreFilter = !status.moreFilter" variant="info">{{ status.moreFilter ? '較少' : '更多' }}篩選</b-button>
      </div>

      <div class="btn-area">
        <div class="auto-empty">
          <b-form-checkbox switch size="lg" v-model="status.autoEmpty">自動清空</b-form-checkbox>
        </div>

        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getMember(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <b-tooltip
      target="blur_info"
      placement="top"
      title="契約編號、業務編號、業務姓名、業務身分證、要助人姓名、要助人身分證、互助人姓名、互助人身分證、受款人姓名、受款人身分證" />

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getMember"
      tableId="contract"
    >
      <template #cell(status)="row">
        {{ getRightsInterests(row.item.status).text }}
      </template>

      <template #cell(member_name)="row">
        <div>{{ row.item.member_name }}</div>

        <div>{{ maskData(row.item.member_ID_number, 'ID') }}</div>

        <div>{{ calculateAge(row.item.member_birthday) }}歲</div>
      </template>

      <template #cell(pay_name)="row">
        <div>{{ row.item.pay_name }}</div>

        <div>{{ maskData(row.item.pay_ID_number, 'ID') }}</div>

        <div>{{ convertRocDate(row.item.pay_birthday) }}</div>
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(pay_ID_number)="row">
        {{ maskData(row.item.pay_ID_number, 'ID') }}
      </template>

      <template #cell(seniority)="row">
        {{ row.item.seniority_month }}個月 ({{ row.item.seniority_day }}天)
      </template>

      <template #cell(sales_number)="row">
        <div class="nowrap">{{ row.item.sales_number }}</div>

        <div class="nowrap">{{ row.item.sales_name }}</div>
      </template>

      <template #cell(frequency)="row">
        <div class="nowrap">停效：{{ row.item.stop_count }}</div>

        <div class="nowrap">已繳：{{ row.item.pay_count }}</div>

        <div class="nowrap">未繳：{{ row.item.unpay_count }}</div>

        <div class="nowrap">墊繳：{{ row.item.behalf_count }}</div>
      </template>

      <template #cell(leader)="row">
        <div class="nowrap">儲總：{{ row.item.sales_reserve }}</div>

        <div class="nowrap">總監：{{ row.item.sales_director }}</div>

        <div class="nowrap">經理：{{ row.item.sales_manager }}</div>
      </template>

      <template #cell(other)="row">
        <div v-if="row.item.pickup_at">
          <span>領取：</span><span>{{ convertRocDate(row.item.pickup_at) }}</span>
        </div>

        <div v-if="row.item.behalf_history_date">
          <span>墊繳：</span><span>{{ row.item.behalf_history_date }}</span>
        </div>

        <div v-if="row.item.stop_history_date">
          <span>停效：</span><span>{{ row.item.stop_history_date }}</span>
        </div>

        <div v-if="row.item.stop_bill">
          <span class="text-danger">停止出帳單</span>
        </div>
      </template>

      <template #cell(first_payment_at)="row">
        {{ convertRocDate(row.item.first_payment_at, false) }}
      </template>

      <template #cell(print)="row">
        <div class="print">
          <b-button
            v-if="row.item.unpay_count > 0"
            variant="secondary"
            size="sm"
            @click="generateBill(row.item)"
          >
            帳單
          </b-button>

          <b-button
            variant="light"
            size="sm"
            @click="generateMembershipCard(row.item)"
          >
            會員證
          </b-button>

          <b-button
            variant="success"
            size="sm"
            @click="generateSignReceipt(row.item)"
          >
            簽收回條
          </b-button>

          <!-- <b-button
            variant="warning"
            size="sm"
            @click="generateNormalPaymentFullNotice(row.item)"
          >
            額滿通知函
          </b-button> -->

          <!-- <b-button
            variant="warning"
            size="sm"
            @click="generatePaymentReminderNotice(row.item)"
          >
            催繳通知書
          </b-button> -->
        </div>
      </template>

      <template #cell(function)="row">
        <div class="function">
          <b-button
            variant="info"
            size="sm"
            @click="openContractAddEditModal(row.item.claim_check === 0 ? 'edit' : 'view', row.item)"
          >
            {{ row.item.claim_check === 0 ? '編輯' : '契約詳情'}}
          </b-button>

          <b-button
            variant="warning"
            size="sm"
            v-auth="`update`"
            @click="openUpdateContractStatusModal(row.item)"
          >
            更新狀態
          </b-button>

          <b-button
            variant="dark"
            size="sm"
            @click="openPaymentStatusModal(row.item)"
          >
            繳款情形
          </b-button>

          <b-dropdown text="更多" variant="primary" size="sm">
            <b-dropdown-item
              v-auth="`update`"
              @click="openContractAddEditModal('copy', row.item)"
            >
              加件
            </b-dropdown-item>

            <b-dropdown-item
              v-if="row.item.status !== 2 && row.item.status !== 3"
              @click="openMutualListModal(row.item.id)"
            >
              互助名單
            </b-dropdown-item>

            <b-dropdown-item
              v-if="row.item.status !== 2 && row.item.status !== 3"
              @click="openMemberPostponementListModal(row.item)"
            >
              會員順延名單
            </b-dropdown-item>

            <b-dropdown-item
              v-if="row.item.status !== 2 && row.item.status !== 3"
              @click="openAllPostponementListModal(row.item)"
            >
              全部順延名單
            </b-dropdown-item>

            <b-dropdown-item
              @click="openDiscontinuedModal(row.item)"
            >
              停效
            </b-dropdown-item>

            <b-dropdown-item
              v-if="row.item.status === 2"
              v-auth="`update`"
              @click="cancelDiscontinued(row.item.id)"
            >
              結束停效
            </b-dropdown-item>

            <b-dropdown-item
              @click="openPaymentModal(row.item)"
            >
              墊繳
            </b-dropdown-item>

            <b-dropdown-item
              v-if="row.item.status === 4"
              v-auth="`update`"
              @click="cancelAdvancePayment(row.item.id)"
            >
              結束墊繳
            </b-dropdown-item>

            <b-dropdown-item
              v-auth="`update`"
              @click="openUpdatePaymentModal(row.item)"
            >
              更新墊繳
            </b-dropdown-item>

            <b-dropdown-item
              @click="openLoanModal(row.item)"
            >
              預領
            </b-dropdown-item>
          </b-dropdown>

          <!-- <b-button
            v-if="row.item.status !== 2 && row.item.status !== 3"
            variant="success"
            size="sm"
            @click="openMutualListModal(row.item.id)"
          >
            互助名單
          </b-button> -->

          <!-- <b-button
            v-if="row.item.status !== 2 && row.item.status !== 3"
            variant="primary"
            size="sm"
            @click="openMemberPostponementListModal(row.item)"
          >
            會員順延名單
          </b-button> -->

          <!-- <b-button
            v-if="row.item.status !== 2 && row.item.status !== 3"
            variant="secondary"
            size="sm"
            @click="openAllPostponementListModal(row.item)"
          >
            全部順延名單
          </b-button> -->

          <!-- <b-button
            variant="light"
            size="sm"
            @click="openDiscontinuedModal(row.item)"
          >
            停效
          </b-button> -->

          <!-- <b-button
            v-if="row.item.status === 2"
            variant="danger"
            size="sm"
            @click="cancelDiscontinued(row.item.id)"
          >
            結束停效
          </b-button> -->

          <!-- <b-button
            v-if="row.item.status === 4"
            variant="danger"
            size="sm"
            @click="cancelAdvancePayment(row.item.id)"
          >
            結束墊繳
          </b-button> -->

          <!-- <b-button
            variant="light"
            size="sm"
            @click="openUpdatePaymentModal(row.item)"
          >
            更新墊繳
          </b-button> -->
        </div>
      </template>
    </tables-page>

    <!-- 契約新增或編輯 modal -->
    <contract-add-edit-modal
      v-model="status.contractAddEditModal"
      :data="data.temp_table_data"
      :isNew="status.isNew"
      :isEditable="status.isEditable"
      @sumit="contractAddEdit" />

    <!-- 互助名單 modal -->
    <mutual-list-modal
      v-model="status.mutualListModal"
      :member_id="data.member_id" />

    <!-- 會員順延名單 modal -->
    <member-postponement-list-modal
      v-model="status.memberPostponementListModal"
      :data="data.temp_table_data" />

    <!-- 全部順延名單 modal -->
    <all-postponement-list-modal
      v-model="status.allPostponementListModal"
      :data="data.temp_table_data" />

    <!-- 更新契約狀態 modal -->
    <update-contract-status-modal
      v-model="status.updateContractStatusModal"
      :data="data.temp_table_data"
      @sumit="updateStatus" />

    <!-- 繳款情形 modal -->
    <payment-status-modal
      ref="payment_status_modal"
      v-model="status.paymentStatusModal"
      :data="data.temp_table_data" />

    <!-- 停效 modal -->
    <discontinued-modal
      v-model="status.discontinuedModal"
      :data="data.temp_table_data" />

    <!-- 墊繳 modal -->
    <payment-modal
      v-model="status.paymentModal"
      :data="data.temp_table_data" />

    <!-- 更新墊繳 modal -->
    <update-payment-modal
      v-model="status.updatePaymentModal"
      :data="data.temp_table_data"
      @sumit="updatePayment" />

    <!-- 查詢設定自動扣款資料 modal -->
    <set-auto-apply-modal v-model="status.setAutoApplyModal"/>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :params="data.pdfParams"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <bill v-if="data.printType === 'bill'" :data="data.temp_table_data"></bill>

        <membership-card v-else-if="data.printType === 'membershiCard'" :data="data.temp_table_data"></membership-card>

        <sign-receipt v-else-if="data.printType === 'signReceipt'" :data="data.temp_table_data"></sign-receipt>

        <!-- <full-capacity-notice v-else-if="data.printType === 'normalPaymentFullNotice'" :data="data.temp_table_data"></full-capacity-notice> -->

        <payment-reminder-notice v-else-if="data.printType === 'paymentReminderNotice'" :data="data.temp_table_data"></payment-reminder-notice>
      </template>
    </html-to-pdf>

    <!-- 業務選擇modal -->
    <business-select-modal
      v-model="status.businessSelectModal"
      @select="selectSalesSystem" />

    <!-- 預領 modal -->
    <loan-modal
      v-model="status.loanModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import ContractAddEditModal from"./components/modal/ContractAddEditModal";
import MutualListModal from "@/components/common/Modal/MutualListModal";
import MemberPostponementListModal from '@/components/common/Modal/MemberPostponementListModal';
import AllPostponementListModal from"./components/modal/AllPostponementListModal";
import UpdateContractStatusModal from"./components/modal/UpdateContractStatusModal";
import PaymentStatusModal from"./components/modal/PaymentStatusModal";
import DiscontinuedModal from"./components/modal/DiscontinuedModal";
import PaymentModal from"./components/modal/PaymentModal";
import UpdatePaymentModal from"./components/modal/UpdatePaymentModal";
import datePicker from '@/components/common/DatePicker';
import { convertRocDate, downloadFile, getRocYearAndMonthOfPeriod, maskData, calculateAge, getRightsInterests } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import Bill from '@/components/common/PrintTemplate/Bill';
import MembershipCard from '@/components/common/PrintTemplate/MembershipCard';
import SignReceipt from '@/components/common/PrintTemplate/SignReceipt';
import NormalPaymentFullNotice from '@/components/common/PrintTemplate/NormalPaymentFullNotice';
import PaymentReminderNotice from '@/components/common/PrintTemplate/PaymentReminderNotice';
import billApi from "@/models/API/billApi";
import SetAutoApplyModal from"@/components/common/modal/SetAutoApplyModal";
import BusinessSelectModal from"./components/modal/BusinessSelectModal";
import LoanModal from"./components/modal/LoanModal";

export default {
  name: 'contract',
  components: {
    BreadCrumb,
    TablesPage,
    ContractAddEditModal,
    MutualListModal,
    MemberPostponementListModal,
    AllPostponementListModal,
    UpdateContractStatusModal,
    PaymentStatusModal,
    DiscontinuedModal,
    PaymentModal,
    UpdatePaymentModal,
    datePicker,
    HtmlToPdf,
    Bill,
    MembershipCard,
    SignReceipt,
    NormalPaymentFullNotice,
    PaymentReminderNotice,
    SetAutoApplyModal,
    BusinessSelectModal,
    LoanModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '契約管理', url: '', isActive: true },
          { name: '契約', url: '', isActive: false }
        ]
      },
      options: {
        type: [
          { value: '', text: '全部' },
          { value: 0, text: '正常' },
          { value: 1, text: '身故' },
          { value: 2, text: '停效' },
          { value: 3, text: '除會' },
          { value: 4, text: '墊繳' },
        ],
        helpCheck: [
          { value: '', text: '全部' },
          { value: 1, text: '列為下次互助名單' },
          { value: 0, text: '不列為下次互助名單' },
        ],
        // deferredCheck: [
        //   { value: '', text: '全部' },
        //   { value: 1, text: '列為下次遞延名單' },
        //   { value: 0, text: '不列為下次遞延名單' },
        // ],
        stopHistory: [
          { value: '', text: '全部' },
          { value: 1, text: '是' },
          { value: 0, text: '否' },
        ],
        billPayStatus: [
          { value: '', text: '全部' },
          { value: 1, text: '是' },
          { value: 0, text: '否' },
        ],
        loanStatus: [
          { value: '', text: '全部' },
          { value: 1, text: '目前為預領狀態' },
          { value: 2, text: '曾經為預領狀態' },
        ],
        status: [
          { value: 0, text: '正常' },
          { value: 1, text: '失效' },
          { value: 2, text: '停權' },
        ],
      },
      search: {
        status: '',
        number: '',
        sales_number: '',
        sales_name: '',
        sales_ID_number: '',
        pay_name: '',
        pay_ID_number: '',
        member_name: '',
        member_ID_number: '',
        beneficiary_name: '',
        beneficiary_ID_number: '',
        blur: '',
        join_date_S: '',
        join_date_E: '',
        help_check: null,
        // pay_off_status: 0,
        pay_off_at_S: '',
        pay_off_at_E: '',
        dead_at_S: '',
        dead_at_E: '',
        // deferred_check: null,
        stop_history: null,
        bill_pay_status: null,
        loan_status: null,
        bill_pay_status_at_S: '',
        bill_pay_status_at_E: '',
        sales_id_system: '',
        sales_name_system: '',
        // member_birthday_S: '',
        // member_birthday_E: '',
        // pay_birthday_S: '',
        // pay_birthday_E: '',
        // sales_birthday_S: '',
        // sales_birthday_E: ''
      },
      status: {
        isNew: false,
        isEditable: true,
        contractAddEditModal: false,
        mutualListModal: false,
        memberPostponementListModal: false,
        allPostponementListModal: false,
        updateContractStatusModal: false,
        paymentStatusModal: false,
        discontinuedModal: false,
        paymentModal: false,
        autoEmpty: false,
        updatePaymentModal: false,
        moreFilter: false,
        normalPaymentFullNotice: false,
        paymentReminderNotice: false,
        setAutoApplyModal: false,
        isSalesSystemLoading: false,
        businessSelectModal: false,
        loanModal: false
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "plan",
            label: "組別",
            sortable: true
          },
          {
            key: "status",
            label: "權益",
            sortable: true
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          // {
          //   key: "member_ID_number",
          //   label: "身分證",
          //   sortable: true
          // },
          // {
          //   key: "member_helper_age",
          //   label: "互助人年齡"
          // },
          {
            key: "pay_name",
            label: "要助人",
            sortable: true
          },
          // {
          //   key: "pay_ID_number",
          //   label: "要助人身份證",
          //   sortable: true
          // },
          {
            key: "join_date",
            label: "入會日期",
            sortable: true
          },
          {
            key: "seniority",
            label: "年資"
          },
          {
            key: "sales_number",
            label: "業務",
            sortable: true
          },
          // {
          //   key: "sales_name",
          //   label: "業務姓名",
          //   sortable: true
          // },
          {
            key: "frequency",
            label: "次數"
          },
          // {
          //   key: "stop_count",
          //   label: "停效次數"
          // },
          // {
          //   key: "pay_count",
          //   label: "已繳次數"
          // },
          // {
          //   key: "unpay_count",
          //   label: "未繳次數"
          // },
          // {
          //   key: "behalf_count",
          //   label: "墊繳次數"
          // },
          {
            key: "leader",
            label: "領導"
          },
          // {
          //   key: "sales_reserve",
          //   label: "儲總姓名"
          // },
          // {
          //   key: "sales_director",
          //   label: "總監姓名"
          // },
          // {
          //   key: "sales_manager",
          //   label: "經理姓名"
          // },
          {
            key: "first_payment_at",
            label: "首次繳費"
          },
          {
            key: "remark",
            label: "註記",
            sortable: true
          },
          {
            key: "other",
            label: "其它"
          },
          {
            key: "print",
            label: "列印"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_sort: {
          sortBy: 'member_name',
          sort: 'asc'
        },
        page: {},
        temp_table_data: {},
        member_id: 0,
        printType: null,
        pdfParams: {
          format: 'a4',
          orientation: 'p'
        }
      }
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.contractApi.page);

      // 帶入query的搜尋條件
      this.search = {
        ...this.search,
        ...this.$route.query
      }

      this.getMember();
    },
    convertRocDate,
    maskData,
    calculateAge,
    getRightsInterests,
    // 開啟契約新增或編輯 modal
    openContractAddEditModal(type = 'new', item = null) {
      this.status.isNew = type === 'new' || type === 'copy' ? true : false;

      this.data.temp_table_data = Object.assign({}, item);
      if (type === 'new') {
        this.data.temp_table_data.plan = [];
        this.data.temp_table_data.recommend = 0;
        this.data.temp_table_data.receive = 0;
        this.data.temp_table_data.existing_plan = [];
        this.data.temp_table_data.join_check = 1;
        this.data.temp_table_data.join_amount = 2000;

        this.status.isEditable = true;
      } else if (type === 'edit') {
        this.data.temp_table_data.plan = [item.plan];

        this.status.isEditable = true;
      }  else if (type === 'copy') {
        this.data.temp_table_data.status = 0;
        this.data.temp_table_data.plan = [];
        this.data.temp_table_data.join_date = '';
        this.data.temp_table_data.sales_id = '';
        this.data.temp_table_data.sales_number = '';
        this.data.temp_table_data.sales_name = '';
        this.data.temp_table_data.exclusion_at = '';
        this.data.temp_table_data.exclusion_remark = '';
        this.data.temp_table_data.join_check = 1;
        this.data.temp_table_data.join_amount = 2000;
        this.data.temp_table_data.pickup_at = '';
        this.data.temp_table_data.behalf_count = 0;
        this.data.temp_table_data.pay_off_at = null;

        this.status.isEditable = true;
      } else if (type === 'view') {
        this.data.temp_table_data.plan = [item.plan];
        this.status.isEditable = false;
      }

      this.status.contractAddEditModal = true;
    },
    // 開啟互助名單 modal
    openMutualListModal(id = 0) {
      this.status.mutualListModal = true;
      this.data.member_id = id;
    },
    // 開啟會員順延名單 modal
    openMemberPostponementListModal(item = null) {
      this.status.memberPostponementListModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 開啟全部順延名單 modal
    openAllPostponementListModal(item = null) {
      this.status.allPostponementListModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 開啟契約狀態更新 modal
    openUpdateContractStatusModal(item = null) {
      this.status.updateContractStatusModal = true;

      this.data.temp_table_data = Object.assign({}, item);
    },
    // 開啟繳款詳情 modal
    openPaymentStatusModal(item = null) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.paymentStatusModal = true;
    },
    // 開啟停效 modal
    openDiscontinuedModal(item = null) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.discontinuedModal = true;
    },
    // 開啟墊繳 modal
    openPaymentModal(item = null) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.paymentModal = true;
    },
    // 開啟更新墊繳 modal
    openUpdatePaymentModal(item = null) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.updatePaymentModal = true;
    },
    // 開啟查詢設定自動扣款資料 modal
    opeSetAutoApplyModal() {
      this.status.setAutoApplyModal = true;
    },
    // 開始預領
    openLoanModal(item = null) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.loanModal = true;
    },
    // 查詢契約
    getMember(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const verify = this.paramsCheck();

      if (verify) {
        const params = {
          ...this.search,
          'sortBy': this.data.table_sort.sortBy,
          'sort': this.data.table_sort.sort,
          'PageSize': this.data.page.pageSize,
          'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
        };
        this.contractApi.getMember((response) => {
          const res = response.data;

          this.data.page.totalCount = res.total; // 總筆數
          this.data.table_data = res.data.map(item => {
            return {
              ...item,
              behalf_history_date: this.behalfHistoryDateHandler(item),
              stop_history_date: this.stopHistoryDateHandler(item),
              body_tr_bg: getRightsInterests(item.status).bg_class
            }
          });
        }, params)
      }
    },
    // 參數檢查
    paramsCheck() {
      try {
        let required =
          ['bill_pay_status',
          'bill_pay_status_at_S',
          'bill_pay_status_at_E',
          ];

        const data = this.search;
        const only_one_value_status = required.some(item => {
          return Array.isArray(data[item]) ? data[item].length !== 0 : data[item] != null && data[item] !== '';
        });

        const every_value_status = required.every(item => {
          return Array.isArray(data[item]) ? data[item].length !== 0 : data[item] != null && data[item] !== '';
        });

        if (only_one_value_status && !every_value_status) {
          throw { message: '欄位請填寫完整', title: '契約' };
        }

        return true;
      } catch(message) {
        this.contractApi.toast(() => {}, message, false);

        return false;
      }
    },
    // 墊繳日期顯示處理
    behalfHistoryDateHandler(data) {
      let behalf_history_date = ''

      let new_behalf_history = '';

      if (data.behalf_at && data.behalf_end) new_behalf_history = `${data.behalf_at}~${data.behalf_end}`

      if (data.behalf_history && new_behalf_history) new_behalf_history += `,${data.behalf_history}`
      else if (data.behalf_history) new_behalf_history = data.behalf_history;

      if (new_behalf_history) {
        let list = new_behalf_history.split(',');

        behalf_history_date = list.map(item => {
          const start_date = item.split('~')[0];
          const end_date = item.split('~')[1];

          return `${getRocYearAndMonthOfPeriod(start_date)} ~ ${getRocYearAndMonthOfPeriod(end_date)}`
        }).join(',');
      }

      return behalf_history_date;
    },
    // 停效日期顯示處理
    stopHistoryDateHandler(data) {
      let stop_history_date = ''

      let new_stop_history = '';

      if (data.stop_at && data.stop_end) new_stop_history = `${data.stop_at}~${data.stop_end}`

      if (data.stop_history && new_stop_history) new_stop_history += `,${data.stop_history}`
      else if (data.stop_history) new_stop_history = data.stop_history;

      if (new_stop_history) {
        let list = new_stop_history.split(',');

        stop_history_date = list.map(item => {
          const start_date = item.split('~')[0];
          const end_date = item.split('~')[1];

          return `${getRocYearAndMonthOfPeriod(start_date)} ~ ${getRocYearAndMonthOfPeriod(end_date)}`
        }).join(',');
      }

      return stop_history_date;
    },
    // 新增契約 || 更新契約
    async contractAddEdit () {
      let temp_data = JSON.parse(JSON.stringify(this.data.temp_table_data));
      let promises = [];

      for (const item of this.data.temp_table_data.plan) {
        temp_data.plan = item;

        const promise = await this.contractAddEditApi(temp_data);

        promises.push(promise);
      };

      Promise.all(promises)
        .then((responses) => {
          const successResponse = responses.every((res) => res.code === 0);

          if (successResponse) {
            this.getMember();

            this.status.contractAddEditModal = false;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 新增契約 || 更新契約 api
    contractAddEditApi(params = {}) {
      return new Promise((resolve, reject) => {
        const fun = this.status.isNew ? 'addMember' : 'updateMember';
        const status_text = this.status.isNew ? '新增' : '更新';

        this.contractApi[fun]((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0 ) result = { message: `方案${params.plan}${status_text}成功`, title: '契約' };
          else if (res.code === 1 ) result = { message: `方案${params.plan}${status_text}失敗，同組別已有相同互助人身分證`, title: '契約' };

          this.contractApi.toast(() => {}, result, res.code === 0);

          resolve(res);
        }, params)
      });
    },
    // 計算年資
    calcYearsAndMonths(date) {
      if (!date) return;

      const today = new Date();
      const calc_date =  new Date(date);

      let years = today.getFullYear() - calc_date.getFullYear();
      let months = today.getMonth() - calc_date.getMonth();

      if (today.getDate() < calc_date.getDate()) {
        months--;
      }

      if (months < 0) {
        years--;
        months += 12;
      }

      return { years, months };
    },
    // 更新契約狀態
    updateStatus() {
      this.contractApi.updateStatus((response) => {
        const res = response.data;

        if (res.code === 0) this.getMember();

        this.status.updateContractStatusModal = false;
      }, this.data.temp_table_data)
    },
    // 結束停效
    cancelDiscontinued(id = null) {
      const r = confirm("確定取消停效？");

      if (r) {
        const params = {
          'id': id,
          'stop_cancel': 1,
        }

        this.contractApi.updateStatus((response) => {
          const res = response.data;

          if (res.code === 0) this.getMember();

          this.status.updateContractStatusModal = false;
        }, params)

        return true;
      }
      return false;
    },
    // 結束墊繳
    cancelAdvancePayment(id = null) {
      const r = confirm("確定取消墊繳？");

      if (r) {
        const params = {
          'id': id,
          'behalf_cancel': 1,
        }
        this.contractApi.updateStatus((response) => {
          const res = response.data;

          if (res.code === 0) this.getMember();

          this.status.updatePaymentModal = false;
        }, params)

        return true;
      }
      return false;
    },
    // 改變篩選欄位值
    changeFilterValue(search_key) {
      if (this.status.autoEmpty) {
        for (const [key, value] of Object.entries(this.search)) {
          if (key !== search_key) {
            this.$set(this.search, key, '');
          }
        }
      }
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        status: '',
        number: '',
        sales_number: '',
        sales_name: '',
        sales_ID_number: '',
        pay_name: '',
        pay_ID_number: '',
        member_name: '',
        member_ID_number: '',
        beneficiary_name: '',
        beneficiary_ID_number: '',
        blur: '',
        join_date_S: '',
        join_date_E: '',
        help_check: '',
        // pay_off_status: 0,
        pay_off_at_S: '',
        pay_off_at_E: '',
        dead_at_S: '',
        dead_at_E: '',
        // deferred_check: '',
        stop_history: null,
        bill_pay_status: null,
        loan_status: null,
        bill_pay_status_at_S: '',
        bill_pay_status_at_E: '',
        sales_id_system: '',
        sales_name_system: '',
        // member_birthday_S: '',
        // member_birthday_E: '',
        // pay_birthday_S: '',
        // pay_birthday_E: '',
        // sales_birthday_S: '',
        // sales_birthday_E: ''
      }

      if (Object.keys(this.$route.query).length > 0) this.$router.replace({ query: {} });

      this.getMember(1);
    },
    // 匯出契約EXCEL
    exportMember() {
      this.contractApi.exportMember((response) => {
        if (!response) return;

        downloadFile(response);
      }, this.search)
    },
    // 更新墊繳
    updatePayment() {
      const params = {
        // 'status': 4,
        'id': this.data.temp_table_data.id,
        'behalf_cancel':  1,
        'behalf_fee':  this.data.temp_table_data.behalf_fee,
        'behalf_debt':  this.data.temp_table_data.behalf_debt,
        'behalf_repayment_at': this.data.temp_table_data.behalf_repayment_at,
      }
      this.contractApi.updateStatus((response) => {
        const res = response.data;

        if (res.code === 0) this.getMember();

        this.status.updatePaymentModal = false;
      }, this.data.temp_table_data)
    },
    // 產生帳單(PDF)
    async generateBill(item = null) {
      this.status.resetDom = true;
      this.data.printType = 'bill';
      this.data.pdfParams = {
        format: 'a4',
        orientation: 'p'
      };

      const bill_data = await this.getBill(item);

      if (bill_data.length > 0) {
        this.data.temp_table_data = bill_data[0];

        await this.$nextTick(); // 等待當前更新週期結束

        this.$refs.htmlToPdf.generatePdf();
      } else {
        const result = { message: '契約無未繳帳單', title: '下載帳單' };

        this.billApi.toast(() => {}, result, false);

        this.status.resetDom = false;
        this.data.printType = null;
      }
    },
    // 查詢帳單
    getBill(item) {
      return new Promise((resolve, reject) => {
        const params = {
          'class': 1,
          'number': item.number
        };
        this.billApi.getBill((response) => {
          const res = response.data;

          resolve(res.data);
        }, params)
      });
    },
    // 產生會員證
    async generateMembershipCard(item = null) {
      this.status.resetDom = true;
      this.data.printType = 'membershiCard';
      this.data.pdfParams = {
        format: 'a4',
        orientation: 'p'
      };

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 產生簽收回條
    async generateSignReceipt(item = null) {
      this.status.resetDom = true;
      this.data.printType = 'signReceipt';
      this.data.pdfParams = {
        format: 'a5',
        orientation: 'l'
      };

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 產生額滿通知函
    async generateNormalPaymentFullNotice(item = null) {
      this.status.resetDom = true;
      this.data.printType = 'normalPaymentFullNotice';
      this.data.pdfParams = {
        format: 'a5',
        orientation: 'l'
      };

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 產生催繳通知書
    async generatePaymentReminderNotice(item = null) {
      this.status.resetDom = true;
      this.data.printType = 'paymentReminderNotice';
      this.data.pdfParams = {
        format: 'a5',
        orientation: 'l'
      };

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$set(this.data, 'printType', null);
      this.$forceUpdate();
    },
    // 開啟業務員modal
    openBusinessModal() {
      this.status.businessSelectModal = true;
    },
    // 選擇業務
    selectSalesSystem(item) {
      this.$set(this.search, 'sales_id_system', item.id);
      this.$set(this.search, 'sales_name_system', item.name);

      this.status.businessSelectModal = false;
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .auto-empty {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}

.table-page {
  /deep/ table {
    thead {
      tr {
        th {
          // white-space: nowrap;
        }
      }
    }
    tbody {
      tr {
        td {
          .nowrap {
            white-space: nowrap;
          }
          .print {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
          .function {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 0.5rem;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/contract.vue